"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelFacebook = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelFacebook = function SvgChannelFacebook(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#sc_facebook__paint0_linear)",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.78 15c-25.58.084-47.534 18.447-45.67 45.108.536 7.644 1.452 13.316 5.862 20.746 2.255 3.798 4.31 6.221 7.532 9.201.687.636 1.377 1.366 1.74 2.253.391.955.45 3.758.475 5.699.03 2.266-.488 4.747 1.574 6.305 2.175 1.644 4.483-.061 6.694-.945 1.71-.728 4.885-2.366 6.499-2.777.76-.194 1.42-.1 2.735.223 4.518.929 7.807 1.422 12.513 1.462 6.908.059 13.016-1.204 19.375-3.93 16.118-7.885 25.233-20.626 25.857-38.334.949-26.995-17.808-45.1-45.187-45.01z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.544 57.03c-1.445 0-2.381-1.01-3.41-1.75l-8.58-6.23c-1.89-1.37-2.81-1.986-5.585-1.986-2.15 0-3.928 1.12-5.187 2.617-.228.272-.428.663-.646.976-.225.325-.378.549-.612.885l-3.101 4.755c-.205.33-.346.565-.57.927l-3.692 5.66c-1.42 2.24-3.01 4.35-4.318 6.655-.549.966-1.788 2.09-1.84 3.223-.03.633.212 1.231.698 1.652.95.822 2.136.729 3.037.033.409-.316.717-.466 1.106-.778.386-.31.673-.517 1.091-.79l5.684-4.23.07-.055 7.18-5.244c1.63-1.003 2.824-.124 4.01.712l9.243 6.695c2.466 1.782 5.436 3.367 8.996 1.292 1.599-.932 2.61-2.275 3.519-3.86.32-.56.623-.92.939-1.43l6.742-10.343c.325-.47.583-.955.915-1.454l3.343-5.137c.5-.72 1.196-1.479 1.382-2.359.372-1.762-1.775-3.303-3.678-1.95l-.876.63-.07.056-.136.114c-.384.315-.703.476-1.097.785-3.078 2.414-6.42 4.518-9.462 6.978l-2.475 1.791c-.78.564-1.315 1.16-2.62 1.16z",
    fill: "#0191FF"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_facebook__paint0_linear",
    x1: 60,
    y1: 93.502,
    x2: 60,
    y2: 22.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#036DFD"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 0.502,
    stopColor: "#0192FF"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#00B6F8"
  }))));
};

exports.SvgChannelFacebook = SvgChannelFacebook;